import React, { createContext, useState } from 'react'

const CountryContext = createContext({});
 
export const CountryProvider = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState('');
  return (
    <CountryContext.Provider value={{ selectedCountry, setSelectedCountry }}>
        {children}
    </CountryContext.Provider>
  )
}

export default CountryContext;